import { render, staticRenderFns } from "./CadastroFluxo.vue?vue&type=template&id=5ffb35af&scoped=true&"
import script from "./CadastroFluxo.vue?vue&type=script&lang=js&"
export * from "./CadastroFluxo.vue?vue&type=script&lang=js&"
import style0 from "./CadastroFluxo.vue?vue&type=style&index=0&id=5ffb35af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffb35af",
  null
  
)

export default component.exports